import { useCallback, useState } from 'react';
import { default_input_parameter } from 'modals/constants';
import { v4 as uuidv4 } from 'uuid';

const useForceUpdate = <TArray extends { uuid: string }, T extends Array<TArray>>(
  callBack?: React.Dispatch<React.SetStateAction<T>>,
) => {
  const [force_update, setForceUpdate] = useState<boolean | string>(false);

  const handleForceUpdate = useCallback(() => {
    setForceUpdate(uuidv4());
  }, []);

  const handleUpdateDataFromModal = useCallback(
    (row: T[number], force_update?: boolean) => {
      callBack?.((prev) => {
        const new_parameters = [...prev];
        const row_index = new_parameters.findIndex((item) => item.uuid === row.uuid);

        if (row_index === -1) {
          new_parameters.push({ ...default_input_parameter, ...row, modified: true });
        } else {
          new_parameters[row_index] = {
            ...new_parameters[row_index],
            ...row,
            modified: true,
          };
        }
        return new_parameters as T;
      });
      if (force_update) handleForceUpdate();
    },
    [callBack, handleForceUpdate],
  );

  return { force_update, handleUpdateDataFromModal, handleForceUpdate };
};

export default useForceUpdate;
